/**
 * @generated SignedSource<<beca49e0a3a68701530ae1aedb501691>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportTimeSpentOnCurriculumStatisticCardFragment$data = {
  readonly timeSpentOnCurriculumSecondsReport: {
    readonly allTime: number;
  };
  readonly " $fragmentType": "MemberReportTimeSpentOnCurriculumStatisticCardFragment";
};
export type MemberReportTimeSpentOnCurriculumStatisticCardFragment$key = {
  readonly " $data"?: MemberReportTimeSpentOnCurriculumStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportTimeSpentOnCurriculumStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportTimeSpentOnCurriculumStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "timeSpentOnCurriculumSecondsReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "cc582b2d91f8d990b2cd5767a1253f41";

export default node;
